import React from 'react';
import { UserMapDetailsComponent}  from './UserMapDetails.Component';
import { httpServices }  from '../../../services/httpServices';
import { ErrorPage } from '../../common/error';
import { CustomProgressBar } from '../../common/CustomProgressBar';
import { history } from '../../../helpers/history';

const formFields = {
    src_user: '',
    dest_user: '',
    src_task: '',
    dest_task: '',
    status : 1,
    editId : '',
    filter_status : 1
};
const BASE_PATH = process.env.REACT_APP_BASE_PATH;
export class UserMapDetailsContainer extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            hasPermission: false,
            staffView: false,
            staffEdit: false,
            dataLoaded: false,
            cancel : false,
            save :false,
            formFields : {...formFields},
            errors : {},
            destination_instance: '',
            src_task_list :[],
            dest_task_list : [],
            snackbarOpen : false,
            snackbarMsg : '',
            snackbarVariant : '',
            editSrcTask :"",
            editDestTask:'',
            addSrcTask :"",
            addDestTask:'',
            editSrcTaskList :[],
            editStatus:'',
            editId:'',
            showLoader: false,
            open : false,
            deleteId : 0,
            mapOption : '',
            srcFullName : '',
            dest_add_task_list : [],
            dest_full_name : '',
            dest_user_id : 0,
            destination_active_user_list: [],
            destination_user_list: [],
            editDestTaskList :[],
            src_add_task_list : [],
            synced_task_list : [],
            filtered_sync_list : [],
            user_mapped_list : [],
            addOpen : false,
            addStatus: 1,
            filterViewState : false,
            isFilterApplied: false,
            selectedUser : 0
        };
        this.getList = this.getList.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.snackbarClose = this.snackbarClose.bind(this);
        this.handleEditClick = this.handleEditClick.bind(this);
        this.edit = this.edit.bind(this);
        this.onClose = this.onClose.bind(this);
        this.handleStatusChange =this.handleStatusChange.bind(this);
        this.resetFields = this.resetFields.bind(this);
        this.handleAddTaskClick = this.handleAddTaskClick.bind(this);
        this.handleAddStatusChange = this.handleAddStatusChange.bind(this);
        this.onAddSubmit = this.onAddSubmit.bind(this);
        this.filterView = this.filterView.bind(this);
        this.filterSubmit = this.filterSubmit.bind(this);
        this.handleUserChange = this.handleUserChange.bind(this);
    }
    componentDidMount = () => {
        this.setState({
            destination_instance : this.props.match.params.destination,
            selectedUser: this.props.match.params.id
        });
        this.getList(this.props.match.params.id, this.props.match.params.destination);
    };
    filterView = (anchor, open) => (event) => {
        this.setState({filterViewState : open});
    }; 
    getList = (user_map_id, destination) => {
        let fields = this.state.formFields;
        this.setState({
            showLoader: true
        });
        let apiEndpoint = 'api/settings/syncinstance/listTaskMapping';
            return httpServices.post(apiEndpoint, {user_map_id: user_map_id, destination: destination})
                .then(response => {
                    if (response.data.permission) {
                        let staffView = response.data.staff_view;
                        let staffEdit = response.data.staff_edit;
                        let destination_user_list = staffView ? response.data.destination_user_list : [];
                        let src_task_list = staffView ? response.data.src_task_list : [];
                        let dest_task_list = staffView ? response.data.dest_task_list : [];
                        let task_mapped = staffView ? response.data.task_mapped : [];
                        let dest_add_task_list = staffView ? response.data.dest_add_task_list : [];
                        let dest_full_name = staffView ? response.data.dest_full_name : '';
                        let dest_user_id = staffView ? response.data.dest_user_id : '';
                        let editDestTaskList = staffView ? response.data.edit_dest_task_list : [];
                        let editSrcTaskList = staffView ? response.data.edit_src_task_list : [];
                        let src_add_task_list = staffView ? response.data.src_add_task_list : [];
                        let srcFullName = staffView ? response.data.src_full_name : [];
                        let synced_task_list = staffView ? response.data.synced_task_list : [];
                        let filtered = fields.filter_status === "all" ? synced_task_list : synced_task_list.filter(item => item.status == fields.filter_status);
                        let user_mapped_list = staffView ? response.data.user_mapped_list : [];
                        this.setState({
                            hasPermission: true,
                            dataLoaded: true,
                            staffView: staffView,
                            staffEdit: staffEdit,
                            destination_user_list: destination_user_list,
                            src_task_list: src_task_list,
                            dest_task_list: dest_task_list,
                            task_mapped: task_mapped,
                            showLoader: false,

                            dest_full_name : dest_full_name,
                            dest_add_task_list : dest_add_task_list,
                            dest_user_id : dest_user_id,
                            editDestTaskList : editDestTaskList,
                            editSrcTaskList : editSrcTaskList,
                            src_add_task_list : src_add_task_list,
                            srcFullName : srcFullName,
                            synced_task_list : synced_task_list,
                            user_mapped_list : user_mapped_list,
                            filtered_sync_list: filtered,
                            isFilterApplied: true
                        });
                    } else{
                        this.setState({
                            dataLoaded: true,
                            showLoader: false
                        });
                    }
                })
                .catch(function(error) {
                    console.log("Error: "+error);
                });
    };
    handleEditClick = (id, user_map_id,status, src_id, dest_id, src_path, dest_path) => {
        let fields = this.state.formFields;
        fields['editUserMapId'] = user_map_id;
        fields['editSrcTask'] = src_id;
        fields['editDestTask'] = dest_id;
        fields['editSrcPath'] = src_path; 
        fields['editDestPath'] = dest_path;         
        this.setState({
            open : true,
            editId : id,
            editStatus : status ? 1 : 0,
            editSrcTaskList : this.state.editSrcTaskList,
            editDestTaskList : this.state.editDestTaskList,
            formFields: fields,
        });
    }
    handleAddTaskClick = () =>{
        let fields = this.state.formFields;
        this.setState({
            addOpen : true,
            
        });
    }
    onClose = () => {
        this.setState({
            open: false,
            addOpen: false,
            staffDelete: false,
            errors: {},
            deleteConfirm: false
        }, () => {
            this.resetFields();
        });
    }
    resetFields = () => {
        this.setState(prevState => ({
            formFields: {
                ...prevState.formFields,
                editSrcTask: '',
                editDestTask: '',
                addSrcTask: '',
                addDestTask: '',
                editSrcPath: '',
                editDestPath: '',
            },
            editStatus: '',
            addStatus: 1,
            errors: {}
        }));
    }
    handleOnChange = (evt) => {
        const { name, value } = evt.target;
        this.setState(prevState => ({
            formFields: {
                ...prevState.formFields,
                [name]: value
            }
        }));
    };
    handleValidation(map_option) {
        let formIsValid = true;
        let errors = {};
        if(map_option == 'task'){
            if (!this.state.formFields.addSrcTask) {
                errors["addSrcTask"] = "Cannot be empty";
                formIsValid = false;
            }
            if (!this.state.formFields.addDestTask) {
                errors["addDestTask"] = "Cannot be empty";
                formIsValid = false;
            }
        }
        this.setState({errors : errors});
        return formIsValid;
    }
    snackbarClose = () => {
        this.setState({
            snackbarOpen : false,
        });
    }  
    handleAddStatusChange = (evt, value) => {
        this.setState({
            addStatus : evt.target.value
        });
    }
    edit = (editId, status) => {
        if (editId) {
            let ff = this.state.formFields;
            let formIsValid = true;
            let errors = {};
            let apiEndpoint = 'api/settings/syncinstance/edit';
            if (!this.state.formFields.editSrcTask) {
                errors["editSrcTask"] = "Cannot be empty";
                formIsValid = false;
            }
            if (!this.state.formFields.editDestTask) {
                errors["editDestTask"] = "Cannot be empty";
                formIsValid = false;
            }
            if (formIsValid) {
                let srcTaskList = this.state.editSrcTaskList;
                let newSrcTaskPath =  srcTaskList.filter(mapping => mapping.task_id === ff.editSrcTask)[0]['task_path'];
                let destTaskList = this.state.editDestTaskList;
                let newDestTaskPath =  destTaskList.filter(mapping => mapping.task_id === ff.editDestTask)[0]['task_path'];
                return httpServices.post(apiEndpoint, 
                    { editId: editId, status: status, src_task: ff.editSrcTask, dest_task: ff.editDestTask, user_map_id: ff.editUserMapId, src_task_path: ff.editSrcPath, dest_task_path: ff.editDestPath, newSrcTaskPath : newSrcTaskPath, newDestTaskPath : newDestTaskPath })
                    .then(response => {
                        if (response.data.status) {
                            this.getList(ff.editUserMapId, this.state.destination_instance);
                            this.setState({
                                open: false,
                                snackbarOpen: true,
                                snackbarMsg: "Updated Task successfuly",
                                snackbarVariant: 'success'
                            });
                            this.resetFields();
                        } else {
                            this.setState({
                                snackbarOpen: true,
                                snackbarMsg: "Duplicate entry.Failed to update the value",
                                snackbarVariant: 'error',
                                errors : {}
                            });
                        }
                        
                    })
                    .catch(function (error) {
                        console.log("Error: " + error);
                    });
            }
            else {
                this.setState({ errors: errors });
            }
        }
    }
    handleStatusChange = (evt, value) => {
        this.setState({
            editStatus : evt.target.value
        });
    };
    filterSubmit = () => {
        const status = this.state.formFields.filter_status;
        const sync_list = this.state.synced_task_list;    
        let filtered = [];    
        if (status === "all" || status === "") {
            filtered = sync_list;
        } else {
            filtered = sync_list.filter(item => item.status == status);
        }    
        this.setState({
            filtered_sync_list: filtered,
            isFilterApplied: true,
            filterViewState: false
        });
    };
    handleUserChange = (evt) => {
        if (evt.target.value) {
            window.location.href = BASE_PATH + '/system/instancedetails/view/' + this.state.destination_instance + '/' +evt.target.value;
        }
    }
    onAddSubmit = (map_option) => {
        let map_id = this.props.match.params.id;
        if (this.handleValidation(map_option)) {
            let data = this.state.formFields;
            data.status = this.state.addStatus;
            data.destination = this.state.destination_instance;
            data.map_option = map_option;
            let success_message ='';
            let apiEndpoint = '';           
            if (map_option == 'task') {
                success_message = "Task added successfully";
                apiEndpoint = 'api/settings/syncinstance/saveTaskMapping';
            }
            if(map_id) {
                data.user_map_id = map_id;
            }
            if (data) {
                if (map_option == 'task') {
                    let srcTaskList = this.state.editSrcTaskList;
                    data.srcTaskPath =  srcTaskList.filter(mapping => mapping.task_id === data.addSrcTask)[0]['task_path'];
                    let destTaskList = this.state.editDestTaskList;
                    data.destTaskPath =  destTaskList.filter(mapping => mapping.task_id === data.addDestTask)[0]['task_path'];
                }
                return httpServices.post(apiEndpoint, data)
                    .then(response => {
                        if (response.data.status) {
                            this.getList(map_id, this.state.destination_instance);
                            this.setState({
                                snackbarOpen: true,
                                snackbarMsg: success_message,
                                snackbarVariant: 'success',
                                addOpen : false
                            });
                        }
                        else {
                            this.setState({
                                snackbarOpen: true,
                                snackbarMsg: response.data.error,
                                snackbarVariant: 'error'
                            });
                        }
                        this.resetFields();
                    })
                .catch(function(error) {
                    console.log("Error: "+error);
                });
            }
        }
    }
    render(){
        return(
            <>
            <CustomProgressBar
                loaderOpen={this.state.showLoader}
            />
            {(this.state.dataLoaded) ?
                (this.state.hasPermission)
                ?
                <UserMapDetailsComponent
                    DestinationUserList = {this.state.destination_user_list}
                    FormFields = {this.state.formFields}
                    HandleOnChange = {this.handleOnChange}
                    HandleEditClick = {this.handleEditClick}
                    Errors = {this.state.errors}
                    DestinationInstance = {this.state.destination_instance}
                    SnackbarOpen = {this.state.snackbarOpen}
                    Open = {this.state.open}
                    SnackbarMsg = {this.state.snackbarMsg}
                    SnackbarVariant = {this.state.snackbarVariant}
                    SnackbarClose = {this.snackbarClose}
                    OnSave = {this.edit}
                    StaffView = {this.state.staffView}
                    StaffEdit = {this.state.staffEdit}
                    EditId = {this.state.editId}
                    EditSrcTask = {this.state.editSrcTask}
                    EditDestTask = {this.state.editDestTask}
                    EditStatus = {this.state.editStatus}
                    Close = {this.onClose}
                    HandleStatusChange ={this.handleStatusChange}
        


                    DestinationAddTaskList = {this.state.dest_add_task_list}
                    DestinationFullName = {this.state.dest_full_name}
                    DestinationTaskList = {this.state.dest_task_list}
                    DestinationUserId = {this.state.dest_user_id}
                    DestinationActiveUserList = {this.state.destination_active_user_list}
                    EditDestTaskList = {this.state.editDestTaskList}
                    EditSrcTaskList = {this.state.editSrcTaskList}
                    SrcAddTaskList = {this.state.src_add_task_list}
                    SrcFullName = {this.state.srcFullName}
                    SourceTaskList = {this.state.src_task_list}
                    SyncTaskList = {this.state.isFilterApplied
                        ? this.state.filtered_sync_list
                        : this.state.synced_task_list}
                    HandleAddTaskClick = {this.handleAddTaskClick}
                    AddOpen = {this.state.addOpen}
                    AddSrcTask = {this.state.addSrcTask}
                    AddDestTask = {this.state.addDestTask}
                    OnAddSubmit = {this.onAddSubmit}
                    HandleAddStatusChange = {this.handleAddStatusChange}
                    AddStatus = {this.state.addStatus}
                    FilterViewState = {this.state.filterViewState}
                    FilterView = {this.filterView}
                    FilterStatus = {this.state.formFields.filter_status}
                    FilterSubmit = {this.filterSubmit}
                    UserMappedList = {this.state.user_mapped_list}
                    HandleUserChange = {this.handleUserChange}
                    selectedUser = {this.state.selectedUser}
                />
                : <ErrorPage Message={'You are not authorized to view this page.'} />
            :<></>
            }
            </>
        )
    }
}